<template>
    <div class="container">
        <b-modal v-model="warningModalShow" hide-header ok-only>
            <b-alert variant="warning" show>{{warningModalText}}</b-alert>
        </b-modal>
        <h1>{{langCreatePost.createANewPost[locale]}}</h1>
        <form class="form-create-post" v-on:submit.prevent="submitPost">
            <div v-if="!$store.getters.isAuthenticated">
                <div class="row">
                    <hr class="col" />
                    <h3 class="col">{{langCreatePost.userInfo[locale]}}</h3>
                    <hr class="col" />
                </div>
                <form-input :labelText="langCreatePost.name[locale]" :placeholder="langCreatePost.namePlaceholder[locale]" v-model="user.name" :required="true" :tooltipTitle="langCreatePost.nameToolTip[locale]"/>
                <form-input :labelText="langCreatePost.email[locale]" :placeholder="langCreatePost.emailPlaceholder[locale]" :inputType="'email'" v-model="user.email" :required="true" :tooltipTitle="langCreatePost.emailToolTip[locale]"/>
                <form-input :labelText="langCreatePost.phone[locale]" :placeholder="langCreatePost.phonePlaceholder[locale]" v-model="user.phone" :required="true" :tooltipTitle="langCreatePost.phoneToolTip[locale]"/>
                <form-select :labelText="langCreatePost.selectARole[locale]" v-model="user.role" :options="[{text: langCreatePost.selectARole[locale], value: ''}, {text: langCreatePost.individual[locale], value: 'individual'}, {text: langCreatePost.store[locale], value: 'store'}]" :allowedValues="['individual', 'store']" :required="true" :tooltipTitle="langCreatePost.selectARoleToolTip[locale]"/>
                <form-input v-if="user.role === 'store'" :labelText="langCreatePost.address[locale]" :placeholder="langCreatePost.addressPlaceholder[locale]" v-model="user.address" :required="true" :tooltipTitle="langCreatePost.addressToolTip[locale]"/>
            </div>
            <div class="row">
                <hr class="col" />
                <h3 class="col">{{langCreatePost.basicInfo[locale]}}</h3>
                <hr class="col" />
            </div>
            <from-files-uploader :labelText="langCreatePost.uploadImages[locale]" :inputType="'image'" :files="images" :required="true" :fileChanged="imageAdded" :deleteFile="deleteImage" :tooltipTitle="langCreatePost.uploadImagesToolTip[locale]"/>
            <!--
            <from-files-uploader :labelText="langCreatePost.uploadVideos[locale]" :inputType="'video'" :files="videos" :required="false" :fileChanged="videoAdded" :deleteFile="deleteVideo" :tooltipTitle="langCreatePost.uploadVideosToolTip[locale]"/>
            -->
            <form-input :labelText="langCreatePost.title[locale]" :placeholder="langCreatePost.titlePlaceholder[locale]" v-model="post.title" :required="true" :tooltipTitle="langCreatePost.titleToolTip[locale]"/>
            <form-input :labelText="langCreatePost.description[locale]" :placeholder="langCreatePost.descriptionPlaceholder[locale]" v-model="post.description" :inputType="'textarea'" :tooltipTitle="langCreatePost.descriptionToolTip[locale]"/>
            <form-input :labelText="langCreatePost.price[locale]" :placeholder="langCreatePost.pricePlaceholder[locale]" v-model="post.currentPrice" :inputType="'number'" :required="true" :tooltipTitle="langCreatePost.priceToolTip[locale]"/>
      
            <form-select :labelText="langCreatePost.selectAType[locale]" v-if="filters[locale].Type" v-model="post.type" :options="filters[locale].Type" :allowedValues="filters[locale].Type.map(item => (item.value))" :required="true" :tooltipTitle="langCreatePost.selectATypeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectASubType[locale]" v-if="filters[locale].SubType" v-model="post.subType" :options="filters[locale].SubType" :allowedValues="filters[locale].SubType.map(item => (item.value))" :required="true" :tooltipTitle="langCreatePost.selectASubTypeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectAMaker[locale]" v-if="filters[locale].Maker" v-model="post.maker" :options="filters[locale].Maker.concat(['Other'])" :allowedValues="filters[locale].Maker.map(item => (item.value)).concat(['Other'])" :required="true" :tooltipTitle="langCreatePost.selectAMakerToolTip[locale]"/>
            <form-input :labelText="langCreatePost.otherMakerName[locale]" v-if="post.maker === 'Other'" :placeholder="langCreatePost.otherMakerNamePlaceholder[locale]" v-model="post.otherMaker" :required="post.maker === 'Other'" :tooltipTitle="langCreatePost.otherMakerNameToolTip[locale]"/>
            <form-filter-condition :labelText="langCreatePost.selectACondition[locale]" v-model="post.condition" :options="filters[locale].selectCondtionOptions" :allowedValues="filters[locale].selectCondtionOptions.map(item => (item.value))" :required="true" :tooltipTitle="langCreatePost.selectAConditionToolTip[locale]"/>
            <div style="height: 1rem"/>

            <div class="row">
                <hr class="col" />
                <h3 class="col">{{langCreatePost.locationInfo[locale]}}</h3>
                <hr class="col" />
            </div>
            <!--
            <form-select :labelText="'Select a country'" v-model="post.country" :options="[{text: 'Select a Country', value: undefined}, 'Finland']" :allowedValues="['Finland']" :required="true" :tooltipTitle="'Country is required'"/>
            -->
            <form-select :labelText="langCreatePost.selectACity[locale]" ref="city" v-model="post.city" @change="cityChanged" :options="[{text: langCreatePost.selectACity[locale], value: undefined}].concat(CITIES.map(item =>{return item.Kunta;}).filter(item => !!item).sort((a, b) => {return a.toString().localeCompare(b);}))" :allowedValues="CITIES.map(item =>{return item.Kunta;}).filter(item => !!item)" :required="true" :tooltipTitle="langCreatePost.selectACityToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectAProvince[locale]" ref="province" v-model="post.province" :options="[{text: langCreatePost.selectAProvince[locale], value: undefined}].concat(PROVINCES.map(item => {return item;}).sort((a, b) => {return a.toString().localeCompare(b);}))" :allowedValues="PROVINCES.map(item => {return item;})" :required="true" :tooltipTitle="langCreatePost.selectAProvinceToolTip[locale]" disabled/>
            
            <div class="row">
                <hr class="col" />
                <h3 class="col">{{langCreatePost.moreInfo[locale]}}</h3>
                <hr class="col" />
            </div>

            <form-select :labelText="langCreatePost.selectAFrameSize[locale]" v-if="filters[locale].FrameSize" v-model="post.frameSize" :options="filters[locale].FrameSize" :allowedValues="filters[locale].FrameSize.map(item => (item.value))" :tooltipTitle="langCreatePost.selectAFrameSizeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectAGear[locale]" v-if="filters[locale].Gears" v-model="post.gears" :options="filters[locale].Gears" :allowedValues="filters[locale].Gears.map(item => (item.value))" :tooltipTitle="langCreatePost.selectAGear[locale]"/>

            <form-select :labelText="langCreatePost.selectATyreType[locale]" v-if="filters[locale].TyreType" v-model="post.tyreType" :options="filters[locale].TyreType" :allowedValues="filters[locale].TyreType.map(item => (item.value))" :tooltipTitle="langCreatePost.selectATyreTypeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectAMaterial[locale]" v-if="filters[locale].Material" v-model="post.material" :options="filters[locale].Material" :allowedValues="filters[locale].Material.map(item => (item.value))" :tooltipTitle="langCreatePost.selectAMaterialToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectABreakType[locale]" v-if="filters[locale].BreakType" v-model="post.breakType" :options="filters[locale].BreakType" :allowedValues="filters[locale].BreakType.map(item => (item.value))" :tooltipTitle="langCreatePost.selectABreakTypeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectASuspensionType[locale]" v-if="filters[locale].SuspensionType" v-model="post.suspensionType" :options="filters[locale].SuspensionType" :allowedValues="filters[locale].SuspensionType.map(item => (item.value))" :tooltipTitle="langCreatePost.selectASuspensionTypeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectAGender[locale]" v-if="filters[locale].Gender" v-model="post.gender" :options="filters[locale].Gender" :allowedValues="filters[locale].Gender.map(item => (item.value))" :tooltipTitle="langCreatePost.selectAGenderToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectANumOfWheels[locale]" v-if="filters[locale].NumOfWheels" v-model="post.numOfWheels" :options="filters[locale].NumOfWheels" :allowedValues="filters[locale].NumOfWheels.map(item => (item.value))" :tooltipTitle="langCreatePost.selectANumOfWheelsToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectAWheelSize[locale]" v-if="filters[locale].WheelSize" v-model="post.wheelSize" :options="filters[locale].WheelSize" :allowedValues="filters[locale].WheelSize.map(item => (item.value))" :tooltipTitle="langCreatePost.selectAWheelSizeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectAMudGuardType[locale]" v-if="filters[locale].MudGuardType" v-model="post.mudGuardType" :options="filters[locale].MudGuardType" :allowedValues="filters[locale].MudGuardType.map(item => (item.value))" :tooltipTitle="langCreatePost.selectAMudGuardTypeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectARackType[locale]" v-if="filters[locale].RackType" v-model="post.rackType" :options="filters[locale].RackType" :allowedValues="filters[locale].RackType.map(item => (item.value))" :tooltipTitle="langCreatePost.selectARackTypeToolTip[locale]"/>
            <form-select :labelText="langCreatePost.selectABasketType[locale]" v-if="filters[locale].BasketType" v-model="post.basketType" :options="filters[locale].BasketType" :allowedValues="filters[locale].BasketType.map(item => (item.value))" :tooltipTitle="langCreatePost.selectABasketTypeToolTip[locale]"/>

            <form-radio-boxes :labelText="langCreatePost.isLockIncluded[locale]" :options="[{value:true, text:langCreatePost.yes[locale]}, {value:false, text:langCreatePost.no[locale]}, {value:undefined, text:langCreatePost.notSure[locale]}]" v-model="post.lockIncluded" :tooltipTitle="langCreatePost.isLockIncludedToolTip[locale]"/>
            <form-radio-boxes :labelText="langCreatePost.isFrontLightIncluded[locale]" :options="[{value:true, text:langCreatePost.yes[locale]}, {value:false, text:langCreatePost.no[locale]}, {value:undefined, text:langCreatePost.notSure[locale]}]" v-model="post.frontLightIncluded" :tooltipTitle="langCreatePost.isFrontLightIncludedToolTip[locale]"/>
            <form-radio-boxes :labelText="langCreatePost.isRareLightIncluded[locale]" :options="[{value:true, text:langCreatePost.yes[locale]}, {value:false, text:langCreatePost.no[locale]}, {value:undefined, text:langCreatePost.notSure[locale]}]" v-model="post.rareLightIncluded" :tooltipTitle="langCreatePost.isRareLightIncludedToolTip[locale]"/>
            <form-radio-boxes :labelText="langCreatePost.legStandExist[locale]" :options="[{value:true, text:langCreatePost.yes[locale]}, {value:false, text:langCreatePost.no[locale]}, {value:undefined, text:langCreatePost.notSure[locale]}]" v-model="post.legStandExists" :tooltipTitle="langCreatePost.legStandExistToolTip[locale]"/>
<!--
            <label for="post-image-input" class="label text-left">Images</label>
            <div class="input-group mb-3">
                <div class="form-control" style="height: 65px">
                    <font-awesome-icon class="uploader-icon" icon="upload" size="3x" onclick="document.getElementById('post-image-input').click(); return false;"/>
                    <input type="file" id="post-image-input" ref="postImage" v-on:change.stop="imageChange"/>
                </div>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="images.length > 0 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Must have atleast one image`">
                        <font-awesome-icon style="margin: auto" :icon="images.length > 0 ? 'check' : 'exclamation'"/>
                    </span>
                </div>
            </div>
            <div class="container images">
                <div class="image" v-for="(image, i) in images" v-bind:key="i">
                    <img :src="image.uri" />
                    <font-awesome-icon style="cursor: pointer; color: red; font-size: 25px; position: absolute; top: -10px; right: -8px; z-index: 2" icon="times" v-on:click.stop="image.splice(i, 1)"/>
                </div>
            </div>

            <label for="post-video-input" class="label text-left">Videos</label>
            <div class="input-group mb-3">
                <div class="form-control" style="height: 65px">
                    <font-awesome-icon class="uploader-icon" icon="upload" size="3x" onclick="document.getElementById('post-video-input').click(); return false;"/>
                
                    <input type="file" id="post-video-input" ref="postVideo" v-on:change.stop="videoChange"/>
                </div>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="videos.length > 0 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Only videos here`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            <div class="container thumbnails">
                <div class="thumbnail" v-for="(_, i) in videos" v-bind:key="i">
                    <font-awesome-icon class="play-btn" size="5x" :icon="['fab', 'youtube']"/>
                    <font-awesome-icon style="cursor: pointer; color: red; font-size: 25px; position: absolute; top: -10px; right: -8px; z-index: 2" icon="times" v-on:click.stop="videos.splice(i, 1)"/>
                </div>
            </div>

            <label for="country" class="label text-left">Country</label>
            <div class="input-group mb-3">
                <b-form-select id="country" v-model="post.country" :options="formSelect.country.text[locale]" required/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.country.text[locale].indexOf(post.country) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Country for the post`">
                        <font-awesome-icon style="margin: auto" :icon="formSelect.country.text[locale].indexOf(post.country) > -1 ? 'check' : 'exclamation'"/>
                    </span>
                </div>
            </div>

            <label for="province" class="label text-left">Province</label>
            <div class="input-group mb-3">
                <b-form-select id="province" v-model="post.province" :options="formSelect.province.text[locale]" required/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.province.text[locale].indexOf(post.province) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Province for the post`">
                        <font-awesome-icon style="margin: auto" :icon="formSelect.province.text[locale].indexOf(post.province) > -1 ? 'check' : 'exclamation'"/>
                    </span>
                </div>
            </div>

            <label for="city" class="label text-left">City</label>
            <div class="input-group mb-3">
                <b-form-select id="city" v-model="post.city" :options="formSelect.city.text[locale]" required/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.city.text[locale].indexOf(post.city) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`City for the post`">
                        <font-awesome-icon style="margin: auto" :icon="formSelect.city.text[locale].indexOf(post.city) > -1 ? 'check' : 'exclamation'"/>
                    </span>
                </div>
            </div>

            <label for="material" class="label text-left">Material</label>
            <div class="input-group mb-3">
                <b-form-select id="material" v-model="post.material" :options="formSelect.materials.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.materials.text[locale].indexOf(post.material) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Material for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="break-type" class="label text-left">Break Type</label>
            <div class="input-group mb-3">
                <b-form-select id="break-type" v-model="post.breakType" :options="formSelect.breakTypes.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.breakTypes.text[locale].indexOf(post.breakType) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Break type for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="suspension-type" class="label text-left">Suspension Type</label>
            <div class="input-group mb-3">
                <b-form-select id="suspension-type" v-model="post.suspensionType" :options="formSelect.suspensionTypes.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.suspensionTypes.text[locale].indexOf(post.suspensionType) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Suspension type for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="gender" class="label text-left">Gender</label>
            <div class="input-group mb-3">
                <b-form-select id="gender" v-model="post.gender" :options="formSelect.genders.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.genders.text[locale].indexOf(post.gender) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Gender for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="frame-size" class="label text-left">Frame Size</label>
            <div class="input-group mb-3">
                <b-form-select id="frame-size" v-model="post.frameSize" :options="formSelect.frameSizes.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.frameSizes.text[locale].indexOf(post.frameSize) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Frame size for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="gears" class="label text-left">Gears</label>
            <div class="input-group mb-3">
                <b-form-select id="gears" v-model="post.gears" :options="formSelect.gears.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.gears.text[locale].indexOf(post.gears) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Gears for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="num-of-wheels" class="label text-left">Number of wheels</label>
            <div class="input-group mb-3">
                <b-form-select id="num-of-wheels" v-model="post.numOfWheels" :options="formSelect.numberOfWheels.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.numberOfWheels.text[locale].indexOf(post.numOfWheels) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Number of wheels for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="wheel-size" class="label text-left">Wheel Size</label>
            <div class="input-group mb-3">
                <b-form-select id="wheel-size" v-model="post.wheelSize" :options="formSelect.wheelSizes.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.wheelSizes.text[locale].indexOf(post.wheelSize) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Wheel size for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>
            
            <label for="tyre-type" class="label text-left">Tyre type</label>
            <div class="input-group mb-3">
                <b-form-select id="tyre-type" v-model="post.tyreType" :options="formSelect.wheelSizes.text[locale]"/>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="formSelect.wheelSizes.text[locale].indexOf(post.tyreType) > -1 ? 'text-success' : undefined" v-b-tooltip.hover :title="`Wheel size for the post`">
                        <font-awesome-icon style="margin: auto" icon="check"/>
                    </span>
                </div>
            </div>

            <label for="front-mudguard-exists" class="label text-left">Front mudguard exists</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="front-mudguard-exists" class="form-control checkboxes" v-model="post.frontMudGuardExist">
                </b-form-checkbox>
            </div>

            <label for="rear-mudguard-exists" class="label text-left">Rear mudguard exists</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="rear-mudguard-exists" class="form-control checkboxes" v-model="post.rearMudGuardExist">
                </b-form-checkbox>
            </div>

            <label for="front-basket-exists" class="label text-left">Front basket exists</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="front-basket-exists" class="form-control checkboxes" v-model="post.frontBasketExists">
                </b-form-checkbox>
            </div>

            <label for="rear-basket-exists" class="label text-left">Rear basket exists</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="rear-basket-exists" class="form-control checkboxes" v-model="post.rearBasketExists">
                </b-form-checkbox>
            </div>

            <label for="front-rack-exists" class="label text-left">Front rack exists</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="front-rack-exists" class="form-control checkboxes" v-model="post.frontRackExists">
                </b-form-checkbox>
            </div>

            <label for="rear-rack-exists" class="label text-left">Rear rack exists</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="rear-rack-exists" class="form-control checkboxes" v-model="post.rearRackExists">
                </b-form-checkbox>
            </div>

            <label for="lock-included" class="label text-left">Lock included</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="lock-included" class="form-control checkboxes" v-model="post.lockIncluded">
                </b-form-checkbox>
            </div>

            <label for="front-light-included" class="label text-left">Front light included</label>
            <div class="input-group mb-3">
                <b-form-checkbox id="front-light-included" class="form-control checkboxes" v-model="post.frontLightIncluded">
                </b-form-checkbox>
            </div>
-->
            <b-alert :variant="statusOk ? 'success':'danger'" :show="!!errMessage || !!okMessage">
                <router-link v-if="okMessage" :to="okMessage.link">{{okMessage.text}}</router-link>
                <span v-else>{{errMessage}}</span>
            </b-alert>

            <nettipyora-button v-bind:text="langCreatePost.submit[locale]" :className="'btn-info'" v-bind:loading="creating" v-bind:type="'normal'" v-bind:submit="true" />
        </form>
        <br />
    </div>
</template>

<script>
/* eslint-disable no-console */
import NettipyoraButton from "@/components/NettipyoraButton";
//import FormCheckBoxes from '@/components/FormCheckBoxes';
import FormRadioBoxes from '@/components/FormRadioBoxes';
import FormSelect from '@/components/FormSelect';
import FormInput from '@/components/FormInput';
import FromFilesUploader from '@/components/FormFilesUploader';
import FormFilterCondition from '@/components/FormFilterCondition';
import { mapState } from 'vuex';
import fileUploaderMixin from '@/mixins/fileUploaderMixin';
import { CITIES, PROVINCES } from '@/store/constant';
import langCreatePost from '@/store/lang/createPost';

export default {
    name: "create-post",
    mixins: [fileUploaderMixin],
    components: {
        NettipyoraButton,
        //FormCheckBoxes,
        FormRadioBoxes,
        FormSelect,
        FormInput,
        FromFilesUploader,
        FormFilterCondition
    },
    data() {
        return {
            CITIES, PROVINCES, langCreatePost,
            options: [],
            item: "",
            images: [],
            videos: [],
            imageDeleting: false,
            warningModalShow: false,
            warningModalText: "",
            user: {
                role: ''
            },
            post: {
                title: "",
                description: "",
                currentPrice: 0,
                frameSize: null,
                gears: null,
                type: null,
                maker: null,
                subType: null,
                condition: null,
                imageURIs: [],
                //country: null,
                province: null,
                city: null,
                material: null,
                breakType: null,
                suspensionType: null,
                gender: null,
                numOfWheels: null,
                wheelSize: null,
                tyreType: null,
                mudGuardType: null,
                rackType: null,
                basketType: null,
                lockIncluded: undefined,
                frontLightIncluded: undefined,
                rareLightIncluded: undefined,
                legStandExists: undefined
            }
        };
    },
    computed: mapState({
        locale: state => state.locale,
        filters: state => state.filters,
        statusOk: state => state.CreatePost.statusOk,
        errMessage: state => state.CreatePost.errMessage,
        okMessage: state => state.CreatePost.okMessage,
        creating: state => state.CreatePost.creating
    }),
    methods: {
        cityChanged(val) {
            for(let i=0; i<this.CITIES.length; i++) {
                if(this.CITIES[i].Kunta === val) {
                    this.post.province = this.CITIES[i].Maakunta;
                    return;
                }
            }
        },
        imageAdded(files) {
            if(files[0].type.indexOf('image') < 0 ) {
                this.warningModalText = this.locale === "en" ? "Invalid file type. Must be an image.":"Väärä tiedostomuoto. Tiedoston muotona pitää olla kuva.";
                return this.warningModalShow = true;
            } 
            this.images.push({uri: URL.createObjectURL(files[0]), file: files[0]});
        },
        deleteImage(index) {
            this.images.splice(index, 1);
        },
        videoAdded(files) {
            if(files[0].type.indexOf('video') < 0 ) {
                this.warningModalText = this.locale === "en" ? "Invalid file type. Must be an video.":"Väärä tiedostomuoto. Tiedoston muotona pitää olla video.";
                return this.warningModalShow = true;
            } 
            this.videos.push({uri: URL.createObjectURL(files[0]), file: files[0]});
        },
        deleteVideo(index) {
            this.videos.splice(index, 1);
        },
        submitPost() {
            //return console.log("create post", this.post);
            const self = this;
            self.$store.commit('CREATE_POST_CREATING', true);
            if(self.post.maker !== "Other") delete self.post.otherMaker;

            const submit = () => {
                self.multiFileUploader(self.images).then(imageURIs => {
                    self.post.imageURIs = imageURIs;
                    self.multiFileUploader(self.videos).then(videoURIs => {
                        //self.post.videoURIs = videoURIs; //not neede for now
                        const post = Object.fromEntries(Object.entries(JSON.parse(JSON.stringify(self.post))).filter(([_, v]) => v != null));
                        const user = Object.fromEntries(Object.entries(JSON.parse(JSON.stringify(self.user))).filter(([_, v]) => v != null));
                        delete post.otherMaker;
                        self.$store.dispatch('CREATE_POST', {post, user}).then(() => {
                            self.post = {}; self.images = []; self.videos = [];
                            self.scrollToBottom();
                        }).catch(() => {
                            self.deleteFiles(self.post.imageURIs);
                            self.scrollToBottom();
                        });
                    }).catch(err => {
                        console.log(err);
                        self.deleteFiles(self.post.imageURIs);
                        self.$store.commit('CREATE_POST_CREATING', false);
                        self.$store.commit('CREATE_POST_ERROR', self.locale === "en" ? "Error. Video uploading failed":"Virhe. Videon lataus epäonnistui.");
                        self.scrollToBottom();
                    });
                }).catch(err => {
                    console.log(err);
                    self.deleteFiles(self.post.imageURIs);
                    self.$store.commit('CREATE_POST_CREATING', false);
                    self.$store.commit('CREATE_POST_ERROR', self.locale === "en" ? "Error. Image uploading failed":"Virhe. Kuvan lataus epäonnistui.");
                    self.scrollToBottom();
                });
            };

            if(self.post.otherMaker && self.post.maker === "Other") return self.$store.dispatch('CREATE_OTHER_MAKER', {text: self.post.otherMaker}).then((resp) => {
                self.post.maker = resp._id;
                submit();
            }).catch(err => {
                console.log(err.repsonse);
                self.$store.commit('CREATE_POST_CREATING', false);
                if(err.status === 409) return self.$store.commit('CREATE_POST_ERROR', self.locale === "en" ? "Error. Other-maker already exist, please select the maker from the list.":"Virhe. Toinen valmistaja on jo olemassa, valitse valmistaja listalta.");
                self.$store.commit('CREATE_POST_ERROR', self.locale === "en" ? "Error. Image uploading failed":"Virhe. Kuvan lataus epäonnistui.");
                self.scrollToBottom();
            });

            submit();
        },
        scrollToBottom() {
            window.scrollTo(0, document.body.scrollHeight);
        },
        showModalError(text) {
            this.$modal.show('dialog', {
                title: 'Error!',
                text: text,
                buttons: [
                    {
                        title: 'Okay'
                    }
                ]
            });
        }
    }
};
</script>

<style scoped lang="scss">
.image-preview {
    text-align: left;

    .image {
        position: relative;
        height: 100px;
        width: 150px;
        margin: 5px;
        display: inline-block;
        img {
            height: 100px;
            width: 150px;
            border-radius: 1em;
        }
    }
}
</style>
